import React from 'react'
// props { css, checked, idNomina, setValueCheckbox }
class CheckBoxNomina extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            checked: props.initialChecked
        };
    }

    updateValueCheckbox(value){
        this.setState({
            checked: value
        });
        this.props.setValueCheckbox(this.props.idNomina, value);
    }

    handleChange(event) {
        const value = event.target.checked
        this.updateValueCheckbox(value);
    }
    componentDidUpdate(prevProps){
        if(prevProps.initialChecked !== this.props.initialChecked){
           this.updateValueCheckbox(this.props.initialChecked);
        }
    }

    /*componentDidMount(){
        this.updateValueCheckbox(this.props.initialChecked);
    }*/

    render() {
        return (
            <input type="checkbox"
                className={this.props.css}
                onChange={this.handleChange.bind(this)}
                checked={this.state.checked}
                disabled={this.props.disabled}
            />
        );
    };
}

export default CheckBoxNomina;




// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/CheckBoxNomina.jsx